<p class="text-center" style="font-size: 0.83vw;margin-right: 10.7291666666666666vw;">Copyright ©2024 iCodex Solutions Pvt.limited. All Rights Reserved. </p>
